import axios from "axios";
import { get } from "lodash";
import qs from "qs";

const TOKENS_LIST_LOAD = "TOKENS_LIST_LOAD";
const TOKENS_LIST_SUCCESS = "TOKENS_LIST_SUCCESS";
const TOKENS_LIST_FAILED = "TOKENS_LIST_FAILED";
const TOKENS_SET_LOADING = "TOKENS_SET_LOADING";

const TOKENS_FORM_LOAD = "TOKENS_FORM_LOAD";
const TOKENS_FORM_SUCCESS = "TOKENS_FORM_SUCCESS";
const TOKENS_FORM_FAILED = "TOKENS_FORM_FAILED";

const TOKEN_DELETE_LOAD = "TOKEN_DELETE_LOAD";
const TOKEN_DELETE_SUCCESS = "TOKEN_DELETE_SUCCESS";
const TOKEN_DELETE_FAILED = "TOKEN_DELETE_FAILED";

const TOKEN_EDIT_LOAD = "TOKEN_EDIT_LOAD";
const TOKEN_EDIT_SUCCESS = "TOKEN_EDIT_SUCCESS";
const TOKEN_EDIT_FAILED = "TOKEN_EDIT_FAILED";

const TOKEN_VIEW_LOAD = "TOKEN_VIEW_LOAD";
const TOKEN_VIEW_SUCCESS = "TOKEN_VIEW_SUCCESS";
const TOKEN_VIEW_FAILED = "TOKEN_VIEW_FAILED";

const TOKENS_RESET = "TOKENS_RESET";
const TOKENS_RESET_FORM = "TOKENS_RESET_FORM";

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit: process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: "",
  orderMode: "ASC",
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    // case TOKENS_RESET:
    //   return {
    //     ...initialState
    //   };
    case TOKENS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case TOKEN_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case TOKENS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case TOKEN_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case TOKEN_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case TOKENS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case TOKENS_FORM_FAILED:
    case TOKEN_EDIT_FAILED:
    case TOKEN_DELETE_FAILED:
    case TOKENS_LIST_FAILED:
    case TOKEN_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case TOKENS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
    case TOKEN_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        failed: false,
        viewData: action.viewData,
        commentThread: action.commentThread || false,
        viewLoading: false
      };
    case TOKENS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case TOKEN_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case TOKEN_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case TOKENS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
};

export const reset = () => dispatch => {
  dispatch({
    type: TOKENS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: TOKENS_RESET_FORM
  });
};

export const updateTokens = (model, id, data) => dispatch => {
  dispatch({
    type: TOKEN_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios
    .put("/v1/tokens/" + id, obj)
    .then(() =>
      dispatch({
        type: TOKEN_EDIT_SUCCESS
      })
    )
    .catch(error => {
      dispatch({
        type: TOKEN_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
    });
};

export const viewTokens = id => dispatch => {
  dispatch({
    type: TOKEN_VIEW_LOAD
  });
  return axios
    .get("/v1/tokens/" + id)
    .then(response =>
      dispatch({
        type: TOKEN_VIEW_SUCCESS,
        viewData: get(response, "data.data"),
        commentThread: get(response, "data.commentThread", false)
      })
    )
    .catch(error => {
      dispatch({
        type: TOKEN_VIEW_FAILED,
        message: get(error, "response.data.message", null)
      });
    });
};

export const createTokens = (model, data) => dispatch => {
  dispatch({
    type: TOKEN_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios
    .post("/v1/tokens", obj)
    .then(response =>
      dispatch({
        type: TOKEN_EDIT_SUCCESS,
        id: get(response, "data.data.id", null)
      })
    )
    .catch(error => {
      dispatch({
        type: TOKEN_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
    });
};

export const tokenDelete = id => dispatch => {
  dispatch({
    type: TOKEN_DELETE_LOAD
  });
  return axios
    .delete("/v1/tokens/" + id)
    .then(response =>
      dispatch({
        type: TOKEN_DELETE_SUCCESS,
        id
      })
    )
    .catch(error =>
      dispatch({
        type: TOKEN_DELETE_FAILED,
        message: get(error, "response.data.message", null)
      })
    );
};

export const setLoading = loading => dispatch => {
  dispatch({
    type: TOKENS_SET_LOADING,
    loading
  });
};

export const tokensList = (
  page,
  keyword,
  sort,
  filters,
  perPage
) => dispatch => {
  dispatch({
    type: TOKENS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    "per-page": perPage
  };

  params[filters.model] = filters.filters;

  return axios
    .get(
      "/v1/tokens",
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    )
    .then(response => {
      let sort = get(response, "data.sort", null),
        mode = "ASC";
      if (sort && sort.indexOf("-") !== -1) {
        mode = "DESC";
        sort = sort.substr(1);
      }
      return dispatch({
        type: TOKENS_LIST_SUCCESS,
        data: get(response, "data.data", null),
        page: get(response, "data.page", 0),
        limit: get(response, "data.per-page", 0),
        total: get(response, "data.total", 0),
        order: sort,
        orderMode: mode
      });
    })
    .catch(error =>
      dispatch({
        type: TOKENS_LIST_FAILED,
        message: get(error, "response.data.message", null)
      })
    );
};
